import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
/*
 * @Author: Nanxing Xiang
 * @Date: 2021-03-05 10:15:02
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2022-01-19 15:41:35
 * @Description: file content
 */
import { sleep } from '@easyvaas/js-utils';
var isAndroid = /android/.test(navigator.userAgent.toLowerCase());
var isIos = /(ios|ipad|iphone)/.test(navigator.userAgent.toLocaleLowerCase());
/**
 * @description: 初始化Js Bridge
 * @param bridge
 * @return
 */
var initBridge = res => new _Promise(resolve => {
  var bridge = res.callHandler ? res : res.bridge;
  bridge.init((_, responseCallback) => {
    responseCallback({
      'Javascript Responds': 'Wee!'
    });
  });
  resolve(bridge);
});
/**
 * @description: 处理安卓平台js bridge初始化
 * @return
 */
var handleAndroidBridge = () => new _Promise( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (resolve) {
    if (window.WebViewJavascriptBridge) {
      var bridge = yield initBridge(window.WebViewJavascriptBridge);
      resolve(bridge);
    } else {
      document.addEventListener('WebViewJavascriptBridgeReady', /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(function* (event) {
          var bridge = yield initBridge(event);
          resolve(bridge);
        });
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }(), false);
    }
  });
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
/**
 * @description: 处理IOS平台 JS Bridge初始化
 * @return
 */
var handleIOSBridge = () => new _Promise(resolve => {
  if (window.WVJBCallbacks) {
    window.WVJBCallbacks.push(resolve);
  } else {
    window.WVJBCallbacks = [resolve];
  }
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(() => {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
});
/**
 * @description: 计时器 处理JsBridge初始化时间要低于 多少秒才算成功
 * @param
 * @return
 */
var timer = time => new _Promise(resolve => {
  setTimeout(() => {
    resolve('overtime');
  }, time);
});
var JSBridgeState;
(function (JSBridgeState) {
  JSBridgeState[JSBridgeState["uninitialized"] = 0] = "uninitialized";
  JSBridgeState[JSBridgeState["initializing"] = 1] = "initializing";
  JSBridgeState[JSBridgeState["initialized"] = 2] = "initialized";
  JSBridgeState[JSBridgeState["failed"] = 3] = "failed";
})(JSBridgeState || (JSBridgeState = {}));
export default class JSBridge {
  static getBridgeAsync() {
    var _this = this;
    return _asyncToGenerator(function* () {
      if (!isAndroid && !isIos) throw Error('not supported');
      switch (_this.STATE) {
        case JSBridgeState.initialized:
          return _this.BRIDGE;
        case JSBridgeState.initializing:
          {
            //正在初始化等待100ms后重新获取;
            yield sleep(100);
            return _this.getBridgeAsync();
          }
        case JSBridgeState.uninitialized:
          {
            //未初始化，执行初始化程序
            //更新状态为初始化中
            _this.STATE = JSBridgeState.initializing;
            var handler = isAndroid ? handleAndroidBridge : handleIOSBridge;
            var result = yield _Promise.race([handler(), timer(10000)]);
            if (result === 'overtime') {
              _this.STATE = JSBridgeState.failed;
            } else {
              _this.BRIDGE = result;
              _this.STATE = JSBridgeState.initialized;
            }
            return _this.getBridgeAsync();
          }
        case JSBridgeState.failed:
          {
            throw Error('not supported');
          }
      }
    })();
  }
  static init() {
    this.getBridgeAsync();
  }
  static call(name, data) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      return new _Promise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(function* (resolve, reject) {
          try {
            var bridge = yield _this2.getBridgeAsync();
            var string = typeof data === 'string' ? data : JSON.stringify(data);
            bridge.callHandler(name, string, res => {
              if (res) resolve(JSON.parse(res));else resolve(null);
            });
          } catch (e) {
            reject(e);
          }
        });
        return function (_x3, _x4) {
          return _ref3.apply(this, arguments);
        };
      }());
    })();
  }
  static register(name, callback) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      return new _Promise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(function* (resolve, reject) {
          try {
            var bridge = yield _this3.getBridgeAsync();
            bridge.registerHandler(name, (str, cb) => {
              var data = typeof str === 'string' ? JSON.parse(str) : str || '';
              var value = callback(data);
              if (value) {
                cb(JSON.stringify(value));
              } else {
                cb('');
              }
              resolve(value);
            });
          } catch (e) {
            reject(e);
          }
        });
        return function (_x5, _x6) {
          return _ref4.apply(this, arguments);
        };
      }());
    })();
  }
  static registerHandler(name, callback) {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      var bridge = yield _this4.getBridgeAsync();
      bridge.registerHandler(name, (str, cb) => {
        var value = callback(str);
        if (value) {
          cb(JSON.stringify(value));
        } else {
          cb('');
        }
      });
    })();
  }
}
_defineProperty(JSBridge, "STATE", JSBridgeState.uninitialized);
_defineProperty(JSBridge, "BRIDGE", void 0);